import { render } from "./UpgraderCompleteScreen.vue?vue&type=template&id=375f2eba&scoped=true"
import script from "./UpgraderCompleteScreen.vue?vue&type=script&lang=js"
export * from "./UpgraderCompleteScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=375f2eba&lang=scss&scoped=true"
import "./UpgraderCompleteScreen.vue?vue&type=style&index=1&id=375f2eba&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-375f2eba"]])

export default __exports__